import { Typography } from '@mui/material';
import { IEmail } from '../../../../common/models';

export const RegisterModalContent = ({ email }: IEmail) => (
  <Typography>
    We’ve sent an email to {email}. Please click the link in the email to activate your account.
  </Typography>
);
